// Generated by scripts/discover.mjs. Don't edit: add or rename a file instead (CLAUDE.md).

/** The features fetched when a screen first needs them: the top-level keys each holds, and how to load it. */
export const COPY_GROUPS = {
  "code": { keys: ["code"], load: () => import("./copy/code.ts") },
  "company-links": { keys: ["companyLinks"], load: () => import("./copy/company-links.ts") },
  "data": { keys: ["data"], load: () => import("./copy/data.ts") },
  "delivery": { keys: ["delivery"], load: () => import("./copy/delivery.ts") },
  "lists": { keys: ["lists"], load: () => import("./copy/lists.ts") },
  "pages": { keys: ["pages", "routines"], load: () => import("./copy/pages.ts") },
  "questions": { keys: ["questions"], load: () => import("./copy/questions.ts") },
  "settings-brand": { keys: ["settingsBrand"], load: () => import("./copy/settings-brand.ts") },
  "settings-guard": { keys: ["settingsGuard"], load: () => import("./copy/settings-guard.ts") },
  "settings-money": { keys: ["settingsMoney"], load: () => import("./copy/settings-money.ts") },
  "settings": { keys: ["settings"], load: () => import("./copy/settings.ts") },
  "sharing-ui": { keys: ["sharingUi"], load: () => import("./copy/sharing-ui.ts") },
  "sharing": { keys: ["sharing"], load: () => import("./copy/sharing.ts") },
  "staff": { keys: ["staff"], load: () => import("./copy/staff.ts") },
  "understand": { keys: ["understand", "studying"], load: () => import("./copy/understand.ts") },
  "webhooks": { keys: ["webhooks"], load: () => import("./copy/webhooks.ts") },
} as const;

export type CopyGroupId = keyof typeof COPY_GROUPS;
